import { baseReducerState, BaseReducerState } from "Store/Shared/Store/PropTypes";

export type OfferId = string;

export interface OfferState extends BaseReducerState<OfferId> {
    unsaved: {},
    saved: {},
    new: '',
    createFlowId: string | null
}

export const initialOfferState: OfferState = {
    ...baseReducerState,
    unsaved: {},
    saved: {},
    new: '',
    createFlowId: null
}